module.exports = __webpack_public_path__ + "img/召陵区-c.5f66e244.png";